import { MULTIPLE_CHOICE } from '@cavaquinho/shared';
import { registerAnswerDescriber, registerRenderer } from '../registry.ts';
import { MultipleChoiceRenderer, isMultipleChoicePrompt } from './MultipleChoiceRenderer.tsx';

/**
 * No miss describer: the summary's feedback payload is `{ correctIndex,
 * selectedIndex }`, not the options text, so there's nothing short this
 * type can name without the prompt the summary doesn't carry. The summary
 * is complete without one — see `../registry.ts`'s `describeMiss`.
 */
registerRenderer(MULTIPLE_CHOICE, MultipleChoiceRenderer);

/**
 * The review, unlike the summary, DOES carry the prompt — it reads the
 * recorded attempt, and `publicPrompt` was stored alongside the response. So
 * the two indices finally have something to index into, and this type can name
 * the question and both options in the learner's own words rather than as
 * numbers.
 *
 * An index that does not land in `options` describes nothing rather than
 * "undefined": the row keeps its verdict and loses only its detail.
 */
registerAnswerDescriber(MULTIPLE_CHOICE, (publicPrompt, feedback) => {
  if (!isMultipleChoicePrompt(publicPrompt)) return null;
  if (typeof feedback !== 'object' || feedback === null) return null;

  const { correctIndex, selectedIndex } = feedback as {
    correctIndex?: unknown;
    selectedIndex?: unknown;
  };
  if (!Number.isInteger(correctIndex) || !Number.isInteger(selectedIndex)) return null;

  const correct = publicPrompt.options[correctIndex as number];
  const selected = publicPrompt.options[selectedIndex as number];
  if (correct === undefined || selected === undefined) return null;

  return {
    prompt: publicPrompt.question,
    token: correct,
    detail: correctIndex === selectedIndex ? 'você acertou' : `você respondeu ${selected}`,
  };
});
